import { useEffect } from 'react';

// eslint-disable-next-line functional/prefer-readonly-type
export type IOSTouchEvent = TouchEvent & { scale?: number };

export const useBlockZoomIn = (): void => {
  useEffect(() => {
    const handleTouchMove = (event: IOSTouchEvent): void => {
      if ('scale' in event && event.scale !== 1) {
        event.preventDefault();
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);
};
